import { FormikErrors } from 'formik'

import { isValidEmail } from '../../../../../../../local/common/src/utils/validation'

import { Role } from '@user/store/roles/typings'
import { ITenantUser } from '@user/store/users/typings'
import { IEmployee } from '@user/store/employee/typings'
import { ISalesTeamAssignment } from './SalesTeamAssignments/typings'

export interface UpdateUserFormProps {
  user?: ITenantUser
  licenseLeft?: number
  setReAssignDrawerOpen: (value: boolean) => void
  initialActive?: boolean
  openReAssignDrawerAfterSave?: boolean
}

export interface IUserFormModel {
  emailUnique: boolean | undefined
  externalUser: IEmployee | null
  firstName: string
  lastName: string
  emailAddress: string
  id: string | null
  role: Role | undefined
  salesTeamAssignments: ISalesTeamAssignment[]
  originalEmailAddress: string
  isActive: boolean
}

export const userFormInitialValues: IUserFormModel = {
  emailUnique: undefined,
  externalUser: null,
  firstName: '',
  lastName: '',
  emailAddress: '',
  id: '',
  role: undefined,
  salesTeamAssignments: [],
  originalEmailAddress: '',
  isActive: true,
}

export interface IFormikSalesTeamAssignment {
  salesTeamId: string
  salesTeamPositionId: string
}

export interface IFormikUserModel
  extends Omit<ITenantUser, 'externalUserId' | 'roles'> {
  emailUnique: boolean
  externalUser: IEmployee | null
  role: Role | undefined
  salesTeamAssignments: IFormikSalesTeamAssignment[]
}

export interface ICheckUniqueEmailResponse {
  isUnique: boolean
  errorMessage: string
}

export type DeactivationMessageType =
  | 'default'
  | 'licensing'
  | 'records'
  | 'emailInUse'
  | 'userInUse'
  | 'mappedDeactivated'
// ========== V A L I D A T I O N ==========

const validateUserFormCommon = (model: IUserFormModel) => {
  const errors: FormikErrors<IUserFormModel> = {}

  if (!model.role) errors.role = 'Please select a Role'

  if (!model.role?.systemCreated) {
    if (model.salesTeamAssignments.length === 0) {
      errors.salesTeamAssignments = 'You must assign at least one Sales Team'
    }

    model.salesTeamAssignments.map((row, index) => {
      if (!row.salesTeamId) {
        errors[`salesTeamAssignments[${index}].salesTeamId`] =
          'You must select a Sales Team'
      }
      if (!row.salesTeamPositionId) {
        errors[`salesTeamAssignments[${index}].salesTeamPositionId`] =
          'Required*'
      }
    })
  }
  return errors
}

export const validateMappedUserForm = async (model: IUserFormModel) => {
  const errors: FormikErrors<IUserFormModel> = validateUserFormCommon(model)
  if (!model.externalUser) errors.externalUser = 'Please select an Employee'
  if (model.emailUnique != undefined && !model.emailUnique)
    errors.externalUser = 'Email already in use'

  return errors
}

export const validateUnmappedUserForm = async (model: IUserFormModel) => {
  const errors: FormikErrors<IUserFormModel> = validateUserFormCommon(model)

  if (model.firstName === '') errors.firstName = 'Required'
  if (model.lastName === '') errors.lastName = 'Required'
  if (model.emailAddress === '') errors.emailAddress = 'Required'
  if (!isValidEmail(model.emailAddress))
    errors.emailAddress = 'Please enter a valid email address'
  if (
    model.emailUnique != undefined &&
    !model.emailUnique &&
    isValidEmail(model.emailAddress) &&
    model.originalEmailAddress != model.emailAddress &&
    model.originalEmailAddress != ''
  )
    errors.emailAddress = 'Email already in use'

  return errors
}
